// Replaces the browser console with something a little bit more useful.
// Example usage:

// import {getConsole} from 'lib/getConsole'
// const console = getConsole('rr', 'ClimbAnimation')
//
// it is HIGHLY recommended to blackbox this script in the Chrome devtools so
// that you can still get appropriate file:line references when logging
// executes.
//
// See here for instructions: https://developer.chrome.com/devtools/docs/blackboxing
// The rule you want to add is /logdown\.js$ with behavior=blackbox
// screenshot: https://cloud.githubusercontent.com/assets/347189/23230249/1a744b1a-f8f8-11e6-9021-9cfbf0ed6b1f.png

import Logdown from 'logdown'

// expose as a window global so we can .enable and .disable things
window.Logdown = Logdown

const currentUserIsAdmin = window.rwgps &&
  window.rwgps.config &&
  window.rwgps.config.currentUser &&
  window.rwgps.config.currentUser.account_level === 11

if (process.env.NODE_ENV === 'production' && !currentUserIsAdmin) {
  Logdown.disable('*')
}

if (process.env.NODE_ENV === 'test') {
  // log output is unintelligible in console, use npm run test-watch if you
  // need to see component-level logging while debugging tests
  Logdown.disable('*')
}

export const getConsole = (feature, topic) => new Logdown({ prefix: `${feature}:${topic}`, markdown: false })
